import { CashBalanceChart } from "components/BooksHomePage/BusinessOverview/CashBalanceChart";
import { Spinner } from "components/DesignSystem/Loader/loader";
import Async from "components/DesignSystem/AsyncComponents/Async";
import { CashBalanceIcon } from "components/icons/CashBalanceIcon";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useGetCashBalanceAnalysisQuery } from "store/apis/financialMetrics";

type CashBalanceProps = {
  startDate: string;
  endDate: string;
};

export const CashBalance = ({ startDate, endDate }: CashBalanceProps) => {
  const entityId = useCurrentEntityId();

  const { data, isLoading, isSuccess, isError } =
    useGetCashBalanceAnalysisQuery(
      { entityId, start_date: startDate, end_date: endDate },
      { skip: !entityId }
    );

  return (
    <div className="t-flex t-flex-col t-gap-4 t-bg-surface t-border t-border-solid t-border-neutral-10 t-rounded-lg t-p-5 sm:t-px-3">
      <div className="t-pb-4 t-border-b t-border-solid t-border-neutral-10 t-border-x-0 t-border-t-0">
        <span className="t-text-subtitle-lg t-text-text-black">
          Cash Movement
        </span>
      </div>
      <Async.Root
        isLoading={isLoading}
        isSuccess={isSuccess}
        isEmpty={!data?.monthly_breakdown?.length}
        isError={isError}
        customLoader={
          <div className="t-flex t-flex-col t-justify-center t-items-center t-h-72 t-gap-3">
            <Spinner />
            <span className="t-text-body-sm t-text-text-30">
              Loading Cash Movement...
            </span>
          </div>
        }
      >
        <Async.Empty>
          <div className="t-flex t-justify-center t-items-center t-h-72  t-text-text-30 t-flex-col sm:t-text-center sm:t-px-4">
            <CashBalanceIcon />
            <span className="t-pt-4">Cash Movement unavailable</span>
            <span className="t-text-body-sm t-mt-2">
              Connect your bank accounts to see cash movement
            </span>
          </div>
        </Async.Empty>
        <Async.ErrorHandler>
          <div className="t-flex t-justify-center t-items-center t-h-72 t-text-red-50">
            Something went wrong
          </div>
        </Async.ErrorHandler>
        <Async.Success>
          {data && <CashBalanceChart data={data} />}
        </Async.Success>
      </Async.Root>
    </div>
  );
};
